/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrokerTopicPartitionLogdir,
    BrokerTopicPartitionLogdirFromJSON,
    BrokerTopicPartitionLogdirFromJSONTyped,
    BrokerTopicPartitionLogdirToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrokerTopicLogdirs
 */
export interface BrokerTopicLogdirs {
    /**
     * 
     * @type {string}
     * @memberof BrokerTopicLogdirs
     */
    name?: string;
    /**
     * 
     * @type {Array<BrokerTopicPartitionLogdir>}
     * @memberof BrokerTopicLogdirs
     */
    partitions?: Array<BrokerTopicPartitionLogdir>;
}

export function BrokerTopicLogdirsFromJSON(json: any): BrokerTopicLogdirs {
    return BrokerTopicLogdirsFromJSONTyped(json, false);
}

export function BrokerTopicLogdirsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerTopicLogdirs {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'partitions': !exists(json, 'partitions') ? undefined : ((json['partitions'] as Array<any>).map(BrokerTopicPartitionLogdirFromJSON)),
    };
}

export function BrokerTopicLogdirsToJSON(value?: BrokerTopicLogdirs | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'partitions': value.partitions === undefined ? undefined : ((value.partitions as Array<any>).map(BrokerTopicPartitionLogdirToJSON)),
    };
}

